export type NpcPhase = 'wander' | 'idle' | 'react' | 'emote';

export type NpcState = {
  id: string;
  x: number;
  y: number;
  phase: NpcPhase;
  phaseUntil: number;
  targetX: number;
  targetY: number;
  emote: string;
};

export type NpcBounds = { minX: number; minY: number; maxX: number; maxY: number };

export type NpcRng = () => number;
export type NpcClock = () => number;

/** Czysty tick NPC — wstrzykiwany RNG/zegar (unit-testowalny). */
export function tickNpc(
  npc: NpcState,
  dtSec: number,
  bounds: NpcBounds,
  rng: NpcRng = Math.random,
  now: NpcClock = () => Date.now(),
): NpcState {
  const t = now();
  let next = { ...npc };

  if (t < next.phaseUntil && next.phase === 'react') {
    return next;
  }

  if (next.phase === 'wander') {
    const dx = next.targetX - next.x;
    const dy = next.targetY - next.y;
    const dist = Math.hypot(dx, dy);
    const speed = 60;
    if (dist < 4) {
      next.phase = 'idle';
      next.phaseUntil = t + 1500 + rng() * 2500;
      next.emote = '';
    } else {
      const step = Math.min(dist, speed * dtSec);
      next.x += (dx / dist) * step;
      next.y += (dy / dist) * step;
    }
  } else if (next.phase === 'idle' || next.phase === 'emote') {
    if (t >= next.phaseUntil) {
      next.phase = 'wander';
      next.targetX = bounds.minX + rng() * (bounds.maxX - bounds.minX);
      next.targetY = bounds.minY + rng() * (bounds.maxY - bounds.minY);
      next.emote = '';
    }
  } else if (next.phase === 'react') {
    next.phase = 'idle';
    next.phaseUntil = t + 1000;
    next.emote = 'heart';
  }

  next.x = Math.min(bounds.maxX, Math.max(bounds.minX, next.x));
  next.y = Math.min(bounds.maxY, Math.max(bounds.minY, next.y));
  return next;
}

export function petNpc(npc: NpcState, now: NpcClock = () => Date.now()): NpcState {
  return {
    ...npc,
    phase: 'react',
    phaseUntil: now() + 800,
    emote: 'heart',
  };
}
